import {
	faDollar,
	faExpand,
	faGamepad,
	faSackDollar,
	faSearchDollar,
	faWindowRestore
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Switch } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import { GameModeType, selectCasinoTheme, setCloseGameAction, setRebuyAction } from '../../../features/casinotheme';
import { selectTheme, ThemeMode } from '../../../features/theme/themeSlice';
import { FormattedMessage, useIntl } from 'react-intl';

type CasinoHeaderBarProps = {
	initialMode: GameModeType;
	onModeChange: (mode: GameModeType) => void;
	onOpenInWindowClick: () => void;
	onFullScreenClick: () => void;
};

const CasinoHeaderBar: React.FC<CasinoHeaderBarProps> = ({
	onModeChange,
	initialMode,
	onFullScreenClick,
	onOpenInWindowClick
}) => {
	const intl = useIntl();
	const [mode, setMode] = useState<GameModeType>(initialMode);
	const theme = useAppSelector(selectTheme);
	const casinoTheme = useAppSelector(selectCasinoTheme);
	const dispatch = useDispatch();
	return (
		<div className="casino-header-container">
			<div className="casino-header-bar">
				<div className="game-mode-selector">
					<span>
						<FontAwesomeIcon icon={faGamepad} />
						&nbsp;&nbsp;
						<Switch
							checked={mode === GameModeType.REAL ? true : false}
							style={{ marginBottom: '6px' }}
							onChange={v => {
								setMode(v ? GameModeType.REAL : GameModeType.DEMO);
								if (onModeChange) onModeChange(v ? GameModeType.REAL : GameModeType.DEMO);
							}}
						/>
						&nbsp;&nbsp;
						<FontAwesomeIcon icon={faSackDollar} />
					</span>
					<span>{mode === GameModeType.REAL ? <FormattedMessage id="casino.game.real"/> : <FormattedMessage id="casino.game.test"/>}</span>
				</div>
				<div className="casino-header-icons">
					<div className="rebuy-game">
						<Button
							size="small"
							onClick={() => {
								dispatch(setRebuyAction(true));
							}}
						>
							<FormattedMessage id="casino.rebuy"/>
						</Button>
					</div>
					<div className="close-game">
						<Button
							size="small"
							onClick={() => {
								dispatch(setCloseGameAction(true));
							}}
						>
							<FormattedMessage id="close"/>
						</Button>
					</div>

					{ThemeMode.DEFAULT && (
						<div
							title={intl.formatMessage({ id: "casino.screen"})}
							className="panel-button pointer"
							onClick={() => {
								if (onFullScreenClick) onFullScreenClick();
							}}
						>
							<FontAwesomeIcon className="icon" icon={faExpand} />
						</div>
					)}
					{ThemeMode.DEFAULT && (
						<div
							title={intl.formatMessage({ id: "casino.window"})}
							className="panel-button pointer"
							onClick={() => {
								if (onOpenInWindowClick) onOpenInWindowClick();
							}}
						>
							<FontAwesomeIcon className="icon" icon={faWindowRestore} />
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default CasinoHeaderBar;
